// Angular Imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
// import { FilterPipeModule } from 'ngx-filter-pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxPaginationModule } from 'ngx-pagination';
import { DocumentRoutingModule } from '../document/document.routing.module';
import { SharedModule } from '../shared/shared.module';
import { AuditRoutingModule } from './audit-routing.module';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
// This Module's Components
import { AuditTrailsComponent } from './audit-trails.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import {MatButtonModule} from '@angular/material/button';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
    imports: [
        FormsModule,
        RouterModule,
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        //FilterPipeModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        AuditRoutingModule,
        NgxPaginationModule,
        MatPaginatorModule ,
        MatTableModule,
        MatSelectModule,
        BsDatepickerModule.forRoot(),
        NgxSpinnerModule
        ],
    declarations: [
        AuditTrailsComponent,
    ],
    exports: [
        AuditTrailsComponent,
    ]
})
export class AuditTrailsModule {

}
